import type { AccessStatusResponse } from '@lunya/contracts'
import { API_PATHS } from '@lunya/contracts'

import { registerMock } from '~/shared/api'

/**
 * Моки слайса access (docs/data-layer.md §10). В браузере без бэкенда гейт всегда открыт:
 * заглушка подписки — не то, обо что должна спотыкаться вёрстка остальных экранов.
 * Экран гейта в этом режиме открывается напрямую по адресу `/gate`.
 */
export function registerAccessMocks(): void {
  registerMock<void, AccessStatusResponse>('GET', API_PATHS.access.status, () => ({
    allowed: true,
    reason: 'gate_disabled',
    channel_url: null,
    grace_ends_at: null,
  }))
}
